import {
  all,
  take,
  call,
  put,
  select,
  actionChannel,
  ActionPattern,
} from 'redux-saga/effects';
import {
  getUploads,
  getUploadsWaiting,
  getAttachmentUploads,
  getAttachmentUploadsWaiting,
} from '../selectors';

const MAXIMUM_CONCURRENT_UPLOADS = 10;

export type UploadQueueName = 'main' | 'attachments';

function* uploadQueueHandler(
  queueName: UploadQueueName,
  uploadAction: any,
  sequenceUploads: boolean
) {
  const uploads = yield select(
    queueName === 'attachments' ? getAttachmentUploads : getUploads
  );
  const activeUploads = uploads.filter(upload => !upload.error);
  const openUploadSlots = sequenceUploads
    ? 1 - activeUploads.length
    : MAXIMUM_CONCURRENT_UPLOADS - activeUploads.length;

  if (openUploadSlots <= 0) {
    // do nothing, we have no space to queue more
    return;
  }

  const waitingUploads = yield select(
    queueName === 'attachments'
      ? getAttachmentUploadsWaiting
      : getUploadsWaiting
  );
  // start downloading the appropriate amount
  yield all(
    waitingUploads
      .slice(0, openUploadSlots)
      .map(upload => put(uploadAction(upload)))
  );
}

export function* uploadQueueWatcher(
  queueName: UploadQueueName,
  watchActions: ActionPattern,
  uploadAction: any,
  sequenceUploads: boolean = false
) {
  const channel = yield actionChannel(watchActions);
  while (true) {
    yield take(channel);
    yield call(uploadQueueHandler, queueName, uploadAction, sequenceUploads);
  }
}
